/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What happened to the subject.
 */
export type CardEventDtoAction = typeof CardEventDtoAction[keyof typeof CardEventDtoAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardEventDtoAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  ACTIVATE: 'ACTIVATE',
  BLOCK: 'BLOCK',
  CANCEL: 'CANCEL',
  REASSIGN: 'REASSIGN',
  SYNC_SUCCESS: 'SYNC_SUCCESS',
  SYNC_FAILURE: 'SYNC_FAILURE',
  SYNC_PAGE: 'SYNC_PAGE',
} as const;
